"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRequiredEquipment = void 0;
var IRequiredEquipment;
(function (IRequiredEquipment) {
    IRequiredEquipment["Dumbbells"] = "Dumbbells";
    IRequiredEquipment["ResistanceBands"] = "Resistance Bands";
    IRequiredEquipment["MedicineBall"] = "Medicine Ball";
    IRequiredEquipment["ExerciseBall"] = "Exercise Ball";
    IRequiredEquipment["Kettlebell"] = "Kettlebell";
    IRequiredEquipment["Mat"] = "Mat";
})(IRequiredEquipment || (exports.IRequiredEquipment = IRequiredEquipment = {}));
//# sourceMappingURL=required-equipment.js.map